// public
import React from 'react';
import PropTypes from 'prop-types';
import { mergeStyles } from '@xingternal/merge-styles';

import base from './TextShell.css';

const TextShell = ({ children, skin, tag = 'p' }) => {
  const styles = mergeStyles(base, skin);
  const Tag = tag;
  return <Tag className={styles.text}>{children}</Tag>;
};

TextShell.propTypes = {
  /**	The content of the component. */
  children: PropTypes.node,
  /** add you styles as skin={text: styles.heroClass} */
  skin: PropTypes.object,
  /** variants h1, h2, h3, h4, h5, h6, p */
  tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p']),
};

export default TextShell;
